<opac-button
  class="help-button"
  [opac-menu-trigger]="helpMenu"
  [ariaLabel]="'tooltip.help' | translate" [opacTooltip]="'tooltip.help' | translate"
  dataTestId="header-help-button"
>
  <opac-icon icon="help" slot="only-icon"></opac-icon>
</opac-button>

<opac-menu #helpMenu>
  <opac-menu-item *ngIf="helpUrl" (click)="handleHelp()">
    <span>
      {{ 'header.showHelp' | translate }}
      <opac-icon class="external-icon" icon="external_link"></opac-icon>
    </span>
  </opac-menu-item>

  <opac-menu-item *ngFor="let button of infoButtons" (click)="handleInfoButton(button)">
    <span>
      {{ button.textButton }}
      <opac-icon class="external-icon" icon="external_link"></opac-icon>
    </span>
  </opac-menu-item>
</opac-menu>

